import React, { useState } from 'react';
import { Info, Leaf, Eye, ChevronRight, Zap, Heart, Shield, Grid, Wheat, Sprout, Flame, Nut } from 'lucide-react';
import avena from '../../assets/images/productos/semillas/Avena.png';
import almendra from '../../assets/images/productos/semillas/Almendra.png';
import maizpalomero from '../../assets/images/productos/semillas/MaizPalomero.png';
import lenteja from '../../assets/images/productos/semillas/Lenteja.png';
import canela from '../../assets/images/productos/semillas/Canela.png';
import mijoblanco from '../../assets/images/productos/semillas/MijoBlanco.png';
import mijorojo from '../../assets/images/productos/semillas/MijoRojo.png';
import jamaica from '../../assets/images/productos/semillas/Jamaica.png';
import frijolpinto from '../../assets/images/productos/semillas/Frijoles.png';
import chicharo from '../../assets/images/productos/semillas/Chicharo.png';

const CatalogoInformativo = () => {
  const [categoriaActiva, setCategoriaActiva] = useState('todos');
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);

const productos = [
  {
    id: 1,
    nombre: "Avena en Grano",
    categoria: "cereales",
    imagen: avena,
    descripcion: "Producto alimenticio utilizado como materia prima para la producción de avena hojuela. Proviene de granos de Avena sativa y Avena bizantina, cultivados en regiones templadas. Los granos deben tener tamaño y color uniformes para garantizar una avena de excelente calidad.",
    envase: "Sacos de 45.36 kg",
    informacionNutricional: {
      calorias: "389 kcal/100g",
      proteinas: "16.9g",
      fibra: "10.6g",
      grasas: "6.9g"
    },
    beneficios: [
      "Reduce los niveles de colesterol en sangre",
      "Proporciona energía de liberación lenta",
      "Rica en beta-glucanos que fortalecen el sistema inmune",
      "Ayuda a controlar los niveles de azúcar en sangre"
    ],
    usos: ["Desayunos nutritivos", "Batidos y smoothies", "Repostería saludable", "Granolas caseras"],
    origen: "Regiones templadas de Europa, Norteamérica y Asia",
    conservacion: "Lugar fresco y seco, hasta 12 meses"
  },
  {
    id: 2,
    nombre: "Avena en Hojuela",
    categoria: "cereales",
    imagen: avena,
    descripcion: "Producto alimenticio para consumo humano, elaborado a partir de granos de Avena sativa y Avena bizantina. Pasa por procesos de cocción, rolado y secado para obtener hojuelas ligeras. Se consume en malteadas, cereales o recetas de repostería.",
    envase: "Sacos de 20 kg",
    informacionNutricional: {
      calorias: "389 kcal/100g",
      proteinas: "16.9g",
      fibra: "10.6g",
      grasas: "6.9g"
    },
    beneficios: [
      "Reduce los niveles de colesterol en sangre",
      "Proporciona energía de liberación lenta",
      "Rica en beta-glucanos que fortalecen el sistema inmune",
      "Ayuda a controlar los niveles de azúcar en sangre"
    ],
    usos: ["Desayunos nutritivos", "Batidos y smoothies", "Repostería saludable", "Granolas caseras"],
    origen: "Regiones templadas de Europa, Norteamérica y Asia",
    conservacion: "Lugar fresco y seco, hasta 12 meses"
  },
  {
    id: 3,
    nombre: "Maíz Palomero",
    categoria: "cereales",
    imagen: maizpalomero,
    descripcion: "Variedad de maíz destinada para consumo humano en forma de palomitas. Su nombre científico es Zea mays everta y presenta granos duros que estallan al calentarse, formando copos tipo 'nieve' o 'mariposa'.",
    envase: "Sacos de 20 kg",
    informacionNutricional: {
      calorias: "365 kcal/100g",
      proteinas: "9.4g",
      fibra: "7.3g",
      grasas: "4.7g"
    },
    beneficios: [
      "Rico en antioxidantes como polifenoles",
      "Buena fuente de fibra dietética",
      "Contiene vitaminas del complejo B",
      "Libre de gluten naturalmente"
    ],
    usos: ["Palomitas caseras", "Snacks saludables", "Decoración culinaria"],
    origen: "México y regiones productoras de América",
    conservacion: "Recipiente hermético, hasta 24 meses"
  },
  {
    id: 4,
    nombre: "Lenteja Eston 1a",
    categoria: "legumbres",
    imagen: lenteja,
    descripcion: "Leguminosa para consumo humano de la especie Lens culinaris. Se cultiva ampliamente en regiones templadas y es valorada por su alto contenido proteico y versatilidad culinaria.",
    envase: "Sacos en 25 Kg, 45.36 Kg y 50 kg",
    informacionNutricional: {
      calorias: "353 kcal/100g",
      proteinas: "25.8g",
      fibra: "11.5g",
      grasas: "1.1g"
    },
    beneficios: [
      "Excelente fuente de proteína vegetal completa",
      "Rica en hierro y ácido fólico",
      "Ayuda a mantener estables los niveles de glucosa",
      "Favorece la salud cardiovascular"
    ],
    usos: ["Sopas y guisos", "Ensaladas nutritivas", "Purés y cremas", "Hamburguesas vegetales"],
    origen: "Regiones mediterráneas, Canadá y Asia",
    conservacion: "Lugar seco y ventilado, hasta 36 meses"
  },
  {
    id: 5,
    nombre: "Canela en Rama Classic",
    categoria: "especias",
    imagen: canela,
    descripcion: "Especia proveniente de la corteza interna del árbol Cinnamomum zeylanicum, originaria de Sri Lanka e India. Se obtiene pelando y enrollando la corteza en largas varas que se usan en repostería y bebidas.",
    envase: ["Churlas de 25 Kg y 12.5 Kg", "Cajas de 20 Kg"],
    informacionNutricional: {
      calorias: "247 kcal/100g",
      proteinas: "4.0g",
      fibra: "53.1g",
      grasas: "1.2g"
    },
    beneficios: [
      "Potente antioxidante natural",
      "Propiedades antiinflamatorias",
      "Ayuda a regular los niveles de azúcar",
      "Mejora la digestión y circulación"
    ],
    usos: ["Bebidas calientes", "Repostería y postres", "Platos salados", "Infusiones medicinales"],
    origen: "Sri Lanka y sur de India",
    conservacion: "Recipiente hermético, protegida de la luz, hasta 36 meses"
  },
  {
    id: 12,
    nombre: "Canela C4 Cortada 5\"",
    categoria: "especias",
    imagen: canela,
    descripcion: "Su nombre científico es Cinnamomum zeylanicum, es originaria de Ceilán, Sri Lanka y es la corteza interna que se extrae pelando y frotando las ramas y que una vez desprendida, es a su vez separada y vuelta a pelar. Las cortezas se enrollan una dentro de otra hasta formar barras las cuales después son cortadas a una longitud de 5 pulgadas, dependiendo la solicitud del cliente son envueltas en celofán o solo se envasan directamente en presentación de 1 Kg.",
    envase: "1 kg en caja 20 paquetes",
    informacionNutricional: {
      calorias: "247 kcal/100g",
      proteinas: "4.0g",
      fibra: "53.1g",
      grasas: "1.2g"
    },
    beneficios: [
      "Potente antioxidante natural",
      "Propiedades antiinflamatorias",
      "Ayuda a regular los niveles de azúcar",
      "Mejora la digestión y circulación"
    ] ,
    usos: ["Bebidas calientes", "Repostería y postres", "Platos salados", "Infusiones medicinales"],
    origen: "China",
    conservacion: "Recipiente hermético, protegida de la luz, hasta 36 meses"
  },
  {
    id: 6,
    nombre: "Mijo Blanco",
    categoria: "cereales",
    imagen: mijoblanco,
    envase: "Sacos de 45.36 kg",
    descripcion: "Grano redondeado de color blanco cremoso, proveniente de Panicum miliaceum L. Se cultiva desde la antigüedad en África y Asia, siendo un cereal libre de gluten apto para celíacos.",
    informacionNutricional: {
      calorias: "378 kcal/100g",
      proteinas: "11.0g",
      fibra: "8.5g",
      grasas: "4.2g"
    },
    beneficios: [
      "Libre de gluten, apto para celíacos",
      "Rico en magnesio y fósforo",
      "Fácil digestión y absorción",
      "Ayuda a alcalinizar el organismo"
    ],
    usos: ["Sustituto del arroz", "Sopas y guisos", "Ensaladas tibias", "Panes sin gluten"],
    origen: "África y Asia",
    conservacion: "Lugar fresco y seco, hasta 18 meses"
  },
  {
    id: 7,
    nombre: "Mijo Rojo",
    categoria: "cereales",
    imagen:mijorojo,
    descripcion: "Grano redondeado de color rojizo oscuro, proveniente de Panicum miliaceum L. Cultivado en África y Asia, es un cereal libre de gluten de fácil digestión.",
    envase: "Sacos de 45.36 kg",
    informacionNutricional: {
      calorias: "378 kcal/100g",
      proteinas: "11.0g",
      fibra: "8.5g",
      grasas: "4.2g"
    },
    beneficios: [
      "Libre de gluten, apto para celíacos",
      "Rico en magnesio y fósforo",
      "Fácil digestión y absorción",
      "Ayuda a alcalinizar el organismo"
    ],
    usos: ["Sustituto del arroz", "Sopas y guisos", "Ensaladas tibias", "Panes sin gluten"],
    origen: "África y Asia",
    conservacion: "Lugar fresco y seco, hasta 18 meses"
  },
  {
    id: 8,
    nombre: "Jamaica",
    categoria: "especias",
    imagen: jamaica,
    envase: "Sacos de 45.36 kg",
    descripcion: "Flor deshidratada de Hibiscus sabdariffa L., utilizada en infusiones y bebidas tradicionales. De color rojo intenso, es rica en antioxidantes y vitamina C.",
    informacionNutricional: {
      calorias: "49 kcal/100g",
      proteinas: "0.4g",
      fibra: "0.3g",
      grasas: "0.6g"
    },
    beneficios: [
      "Alta concentración de antioxidantes",
      "Propiedades diuréticas naturales",
      "Rica en vitamina C y antocianinas",
      "Ayuda a regular la presión arterial"
    ],
    usos: ["Agua fresca tradicional", "Té e infusiones", "Mermeladas y jaleas", "Colorante natural"],
    origen: "África tropical, adaptada a México",
    conservacion: "Lugar seco y oscuro, hasta 24 meses"
  },
  {
    id: 9,
    nombre: "Frijol Pinto Americano",
    categoria: "legumbres",
    imagen: frijolpinto,
    descripcion: "Leguminosa de la especie Phaseolus vulgaris L., originaria de Mesoamérica. Es fuente importante de proteína, fibra, vitaminas y minerales.",
    envase: "Sacos de 25 Kg y 45.36 Kg",
    informacionNutricional: {
      calorias: "347 kcal/100g",
      proteinas: "21.4g",
      fibra: "15.5g",
      grasas: "1.2g"
    },
    beneficios: [
      "Excelente fuente de proteína vegetal",
      "Rico en fibra soluble e insoluble",
      "Contiene folatos y minerales esenciales",
      "Ayuda a mantener la sensación de saciedad"
    ],
    usos: ["Frijoles refritos", "Sopas y caldos", "Ensaladas de legumbres", "Salsas y dips"],
    origen: "Mesoamérica",
    conservacion: "Recipiente hermético, hasta 36 meses"
  },
  {
    id: 10,
    nombre: "Almendra Nonpareil Supreme",
    categoria: "frutos-secos",
    imagen: almendra,
    envase: "Sacos X",
    descripcion: "Fruto seco del almendro (Prunus dulcis), variedad nonpareil, caracterizada por su forma plana, superficie lisa y color café claro. Originaria de regiones mediterráneas y Asia occidental.",
    informacionNutricional: {
      calorias: "579 kcal/100g",
      proteinas: "21.2g",
      fibra: "12.5g",
      grasas: "49.9g"
    },
    beneficios: [
      "Rica en grasas monoinsaturadas saludables",
      "Excelente fuente de vitamina E",
      "Contiene magnesio y calcio",
      "Favorece la salud cardiovascular"
    ],
    usos: ["Snack saludable", "Leche de almendras", "Repostería", "Ensaladas y granolas"],
    origen: "Mediterráneo y Asia occidental",
    conservacion: "Lugar fresco y seco, hasta 12 meses"
  },
  {
    id: 11,
    nombre: "Chícharo Verde Mitad",
    categoria: "legumbres",
    imagen: chicharo,
    descripcion: "Semilla de Pisum sativum L., partida a la mitad y deshidratada. De color verde con ligeras tonalidades amarillas, es utilizada en sopas, purés y ensaladas.",
    envase: "Sacos de 45.36 kg",
    informacionNutricional: {
      calorias: "341 kcal/100g",
      proteinas: "25.8g",
      fibra: "8.3g",
      grasas: "1.2g"
    },
    beneficios: [
      "Alta concentración de proteína vegetal",
      "Rica en fibra y minerales",
      "Bajo índice glucémico",
      "Ayuda a mantener la saciedad"
    ],
    usos: ["Sopas y guisos", "Ensaladas", "Puré de chícharos", "Hamburguesas vegetales"],
    origen: "Europa y Asia",
    conservacion: "Lugar seco y fresco, hasta 24 meses"
  }
];

  const categorias = [
    { id: 'todos', nombre: 'Todos', icon: <Grid className="w-5 h-5" /> },
    { id: 'cereales', nombre: 'Cereales', icon: <Wheat className="w-5 h-5" /> },
    { id: 'legumbres', nombre: 'Legumbres', icon: <Sprout className="w-5 h-5" /> },
    { id: 'especias', nombre: 'Especias', icon: <Flame className="w-5 h-5" /> },
    { id: 'frutos-secos', nombre: 'Frutos Secos', icon: <Nut className="w-5 h-5" /> }
  ];

  const productosFiltrados = categoriaActiva === 'todos' 
    ? productos 
    : productos.filter(p => p.categoria === categoriaActiva);

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-amber-50">
      {/* Header */}
      <header className="bg-white/90 backdrop-blur-md border-b border-orange-200 mt-24">
        <div className="max-w-7xl mx-auto px-2 sm:px-4 py-4 sm:py-6">
          <div className="text-center">
            <div className="flex items-center justify-center gap-3 mb-2">

              <h1 className="text-4xl font-bold bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent">
                Nuestros Productos
              </h1>
            </div>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Conoce en detalle nuestras semillas, granos y frutas secas. 
              Información completa sobre propiedades, beneficios y usos.
            </p>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-2 sm:px-4 py-6 sm:py-8">
        {/* Filtros de categorías */}
        <div className="mb-8 sm:mb-12">
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
            {categorias.map((categoria) => (
              <button
                key={categoria.id}
                onClick={() => setCategoriaActiva(categoria.id)}
                className={`px-6 py-3 rounded-full font-medium transition-all duration-300 flex items-center gap-2 ${
                  categoriaActiva === categoria.id
                    ? 'bg-gradient-to-r from-orange-500 to-amber-500 text-white shadow-lg transform scale-105'
                    : 'bg-white text-gray-600 hover:bg-orange-50 border border-orange-200 hover:border-orange-300 hover:scale-105'
                }`}
              >
                <span className="text-lg">{categoria.icon}</span>
                {categoria.nombre}
              </button>
            ))}
          </div>
        </div>

        {/* Grid de productos */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
          {productosFiltrados.map((producto) => (
            <div
              key={producto.id}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-orange-100 cursor-pointer flex flex-col min-h-[340px]"
              onClick={() => setProductoSeleccionado(producto)}
            >
              {/* Imagen del producto */}
              <div className="h-28 sm:h-32 bg-gradient-to-br from-orange-100 to-amber-100 flex items-center justify-center">
                {typeof producto.imagen === 'string' && producto.imagen.endsWith('.png') ? (
                  <img src={producto.imagen} alt={producto.nombre} className="h-20 sm:h-24 object-contain" />
                ) : (
                  <span className="text-4xl sm:text-5xl">{producto.imagen}</span>
                )}
              </div>

              {/* Contenido básico */}
              <div className="p-3 sm:p-4 flex flex-col gap-0.5 flex-1 justify-between">
                {/* Etiqueta de envase */}
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-lg font-bold text-gray-800">{producto.nombre}</h3>
                  <Eye className="w-5 h-5 text-orange-500 ml-2" />
                </div>
                <p className="text-gray-600 text-sm mb-1 line-clamp-2">
                  {producto.descripcion.split(' ').slice(0, 18).join(' ')}{producto.descripcion.split(' ').length > 18 ? '...' : ''}
                </p>
                {/* Envases principales (en vez de beneficios) */}
                <div className="mb-2 mt-1">
                  <div className="flex flex-wrap gap-1">
                    {producto.envase && Array.isArray(producto.envase)
                      ? producto.envase.map((env, idx) => (
                          <span
                            key={idx}
                            className="px-2 py-1 bg-orange-100 text-orange-700 text-xs rounded-full"
                          >
                            {env}
                          </span>
                        ))
                      : producto.envase ? (
                          <span className="px-2 py-1 bg-orange-100 text-orange-700 text-xs rounded-full">
                            {producto.envase}
                          </span>
                        ) : null}
                  </div>
                </div>
                <button className="w-full bg-gradient-to-r from-orange-500 to-amber-500 text-white py-2 rounded-lg hover:from-orange-600 hover:to-amber-600 transition-all duration-200 flex items-center justify-center gap-2 mt-auto">
                  <Info className="w-4 h-4" />
                  Ver información completa
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Modal de información detallada */}
        {productoSeleccionado && (
          <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-2 sm:p-4">
            <div className="bg-white rounded-3xl w-full max-w-lg sm:max-w-2xl lg:max-w-4xl max-h-[90vh] overflow-y-auto relative">
              {/* Botón cerrar fuera del header */}
              <button
                onClick={() => setProductoSeleccionado(null)}
                className="absolute top-2 right-2 sm:top-4 sm:right-4 z-20 bg-white text-orange-600 hover:bg-orange-100 hover:text-orange-700 rounded-full shadow-lg w-10 h-10 flex items-center justify-center text-3xl font-bold border border-orange-200 transition"
                aria-label="Cerrar"
              >
                ×
              </button>
              {/* Header del modal */}
              <div className="sticky top-0 bg-gradient-to-r from-orange-500 to-amber-500 text-white p-4 sm:p-6 rounded-t-3xl">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-0">
                  <div className="flex items-center gap-2 sm:gap-4 w-full">
                    {typeof productoSeleccionado.imagen === 'string' && productoSeleccionado.imagen.endsWith('.png') ? (
                      <img src={productoSeleccionado.imagen} alt={productoSeleccionado.nombre} className="h-24 sm:h-32 object-contain" />
                    ) : (
                      <span className="text-4xl sm:text-6xl">{productoSeleccionado.imagen}</span>
                    )}
                    <div className="flex-1 min-w-0">
                      <h2 className="text-2xl sm:text-3xl font-bold truncate">{productoSeleccionado.nombre}</h2>
                      <p className="text-orange-100 text-sm sm:text-base">{productoSeleccionado.descripcion}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-4 sm:p-6 grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
                {/* Información nutricional */}
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <Zap className="w-5 h-5 text-orange-500" />
                    Información Nutricional
                  </h3>
                  <div className="bg-orange-50 rounded-xl p-4 space-y-3">
                    {Object.entries(productoSeleccionado.informacionNutricional).map(([key, value]) => (
                      <div key={key} className="flex justify-between items-center">
                        <span className="capitalize text-gray-700">{key.replace(/([A-Z])/g, ' $1').toLowerCase()}:</span>
                        <span className="font-semibold text-orange-600">{value}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Beneficios */}
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <Heart className="w-5 h-5 text-orange-500" />
                    Beneficios para la Salud
                  </h3>
                  <ul className="space-y-2">
                    {productoSeleccionado.beneficios.map((beneficio, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <ChevronRight className="w-4 h-4 text-orange-500 mt-1 flex-shrink-0" />
                        <span className="text-gray-700">{beneficio}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Usos recomendados */}
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <Leaf className="w-5 h-5 text-orange-500" />
                    Usos Recomendados
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {productoSeleccionado.usos.map((uso, index) => (
                      <span
                        key={index}
                        className="px-3 py-2 bg-amber-100 text-amber-800 rounded-lg font-medium"
                      >
                        {uso}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Información adicional */}
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <Shield className="w-5 h-5 text-orange-500" />
                    Información Adicional
                  </h3>
                  <div className="space-y-3">
                    <div>
                      <span className="font-semibold text-gray-700">Origen: </span>
                      <span className="text-gray-600">{productoSeleccionado.origen}</span>
                    </div>
                    <div>
                      <span className="font-semibold text-gray-700">Conservación: </span>
                      <span className="text-gray-600">{productoSeleccionado.conservacion}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CatalogoInformativo;